import type { Theme } from '@mui/material';
import { APP_SHAPE } from '../../constants/colors';

export const authFieldSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: `${APP_SHAPE.radiusMd}px`,
    bgcolor: 'background.paper',
    transition: 'background-color 0.2s ease, box-shadow 0.2s ease',
    '& fieldset': {
      borderColor: 'divider',
    },
    '&:hover fieldset': {
      borderColor: 'text.secondary',
    },
    '&.Mui-focused fieldset': {
      borderWidth: 1.5,
    },
  },
  '& .MuiInputLabel-root': {
    fontWeight: 500,
  },
};

/** Matches MuiButton contained — no one-off heavy shadow. */
export const authSubmitButtonSx = (_theme: Theme) => ({
  mt: 3,
  py: 1.5,
  borderRadius: `${APP_SHAPE.radiusMd}px`,
  fontSize: '1rem',
  boxShadow: 'none',
});

export const authPageSx = {
  minHeight: '100vh',
  bgcolor: 'background.default',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  px: { xs: 3, sm: 4 },
  py: { xs: 6, sm: 4 },
};

export const authFormWidthSx = {
  width: '100%',
  maxWidth: 420,
};

export const authAlertSx = {
  width: '100%',
  mb: 3,
  borderRadius: `${APP_SHAPE.radiusMd}px`,
};
